const Style = {
    // `contents` so the BrandScope wrapper does not become a box between the
    // viewport and the shell — the shell's min-h-screen has to keep measuring
    // against the viewport, or the footer stops pinning on a short page.
    scope: 'contents',
    shell: 'flex min-h-screen flex-col bg-background',
    header: 'flex items-center justify-between border-b border-border px-6 py-4',
    // icon + wordmark, matching HomeNav. The mark is `w-auto` on purpose:
    // /assets/icon.png is ~1.4:1, so a square `w-*` would squash it.
    logo: 'flex items-center gap-2 text-xl font-bold text-primary-600 no-underline',
    logoMark: 'h-7 w-auto shrink-0',
    actions: 'flex items-center gap-3 sm:gap-4',
    theme:
        'flex h-9 w-9 flex-none cursor-pointer items-center justify-center rounded-md border border-border bg-surface text-text-secondary transition-colors duration-150 ease-out hover:border-primary-400 hover:text-primary-600',
    main: 'flex-1',
    // The tenant's own lockup, in the slot the Valetify one used to hold.
    identity: 'flex items-center gap-3 no-underline',
    identityName: 'text-lg font-semibold text-text-primary',
    footer:
        'flex flex-col items-center gap-1 border-t border-border px-6 py-4 text-center text-sm text-text-secondary sm:flex-row sm:justify-between sm:gap-4 sm:text-left',
    attribution:
        'text-xs text-text-muted no-underline underline-offset-4 hover:text-text-secondary hover:underline',
};

export default Style;
